import { FeatureFlag } from '@revelio/core';

import { useUnleashFlag } from '../../../../shared/unleash-flags/use-unleash-flag';
import {
  type GeographyMode,
  PreferenceScope,
  UserPreferenceKey,
  useUserPreferences,
} from '../../../../shared/user-preferences';

export type { GeographyMode };

export const useGeographyMode = (): GeographyMode => {
  const { preferences } = useUserPreferences(PreferenceScope.GLOBAL);
  const geographyUserPreferenceEnabled = useUnleashFlag(
    FeatureFlag.GeographyUserPreference
  );

  return geographyUserPreferenceEnabled &&
    preferences[UserPreferenceKey.Geography] === 'administrative'
    ? 'administrative'
    : 'msa';
};
